import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, EventEmitter, Input, OnDestroy, OnInit, Output, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentService } from '../../../services/component.service';
import { messagefromComponent } from '../../../class/appinterface';
import { IPartner } from '../../../views/crm/interfaces';
export interface ITabCrm {
  id: number,
  icon: string,
  text: string,
  component: string,
  active: boolean,
  istancedData: { [key: string]: any },
}
//ESEMPIO DI UTILIZZO
/*   tabDefinizione: ITabCrm[] = [{
    id: 0,
    icon: 'dx-icon-card',
    text: 'Anagrafica Contatto',
    component: 'NicaAnagraficaComponent',
    active: true,
    istancedData: {
      service: 'CrmContattiGrid',
      api: 'contatti',
      modeEdit: 'customComponent',
      modeEditComponent: 'CrmEditCustomComponent',
      titolo: this.titolo,
      masterKey: 'Cod',
      modifica: true,
      aggiungi: true,
      gridHeight: '600',
      classe: 'mx-auto',
      wingap: false,
      storage: true,
      remoteOperations: false,
      paginate: true,
      dxoscrolling: "virtual",
      dxosorting: "multiple",
      orientamento: 'l',
      formato: 'a4'
    }
  },]; */

@Component({
  selector: 'app-crm-tab-panel',
  templateUrl: './crm-tab-panel.component.html',
  styleUrls: ['./crm-tab-panel.component.css']
})
export class CrmTabPanelComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('dynamicOutletTab', { read: ViewContainerRef, static: true }) dynamicOutletTab!: ViewContainerRef;
  @Input() tabDefinizione: ITabCrm[]
  @Input() dataRelated: { [key: string]: any } = {}
  @Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>();
  isLoading = true
  private $distruggi: Subject<void> = new Subject<void>()
  @Input() partnerData: IPartner = {
    isPartner: false,
    isSegreteria: false,
    id: null
  };
  constructor(private _componentFactoryResolver: ComponentFactoryResolver, private componentService: ComponentService, private cdf: ChangeDetectorRef) {
  }
  ngAfterViewInit(): void {

    this.componentService.castMessage.pipe(takeUntil(this.$distruggi)).subscribe({
      next: (msg: messagefromComponent) => {
        return this.processaMsg(msg)
      },
      error: (errore) => {
        return console.error(errore)
      },
      complete: () => { }
    })
    this.isLoading = false
    this.cdf.detectChanges()
  }
  ngOnDestroy(): void {
    this.$distruggi.next()
    this.$distruggi.complete()
    this.$distruggi.unsubscribe()
  }
  ngOnInit(): void {
    //console.group([this.api, this.masterKey, this.selectedRow])
    //this.creaTabs()

  }

  processaMsg(msg: messagefromComponent) {
    if (!this.tabDefinizione) return;
    if (msg.destComponent !== this.constructor.name) {
      return this.open(this.tabDefinizione[0].component, this.processaDataToSendDynamic(this.tabDefinizione[0].istancedData))
    }
    console.log('', msg)
    switch (msg.traceMessage) {
      case 'selectDiarioAttivita':
        this.tabDefinizione.forEach((item) => {
          if (item.component === msg.Data.Items[0]) {
            item.active = true
            this.open(item.component, this.processaDataToSendDynamic(item.istancedData))
          } else {
            item.active = false
          }
        })
        return
      default:
        this.open(this.tabDefinizione[0].component, this.processaDataToSendDynamic(this.tabDefinizione[0].istancedData))
        return
    }
  }

  async open<T>(componentName: any, data?: Partial<T>): Promise<ComponentRef<any>> {
    this.isLoading = true
    // Svuotare il contenitore
    this.dynamicOutletTab.clear();
    const nativeElement: HTMLElement = this.dynamicOutletTab.element.nativeElement;
    //Cercare il componente
    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === componentName);
    // Risolvere la ComponentFactory
    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(factoryClass);

    // Creare il componente dinamico
    const componentRef = this.dynamicOutletTab.createComponent(componentFactory);
    nativeElement.appendChild(componentRef.location.nativeElement);
    data['partnerData'] = this.partnerData
    // Passare i dati
    if (data) {
      Object.assign(componentRef.instance, data);
    }
    Object.keys(componentRef.instance).forEach(property => {
      const propertyValue = (componentRef.instance as any)[property];
      if (propertyValue instanceof EventEmitter) {
        propertyValue.pipe(takeUntil(this.$distruggi)).subscribe((eventData: any) => {
          this.onAllEvent.emit(eventData)
          //console.log(evento)
        });
      }
    });
    this.isLoading = false
    this.cdf.detectChanges()
    return componentRef;
  }

  onTabClick(event: any) {
    this.open(event.addedItems[0].component, event.addedItems[0].istancedData)
  }

  activeItem() {
    if (this.tabDefinizione) {
      const itemActive: ITabCrm | undefined = this.tabDefinizione.find((x: ITabCrm) => x.active === true);
      return itemActive ? itemActive : undefined;
    } else {
      return undefined;
    }
  }
  processaDataToSendDynamic(configuration: { [key: string]: any }) {
    let dataSend: { [key: string]: any } = {};
    let config = { ...configuration };

    if (config) {
      Object.keys(config).forEach((key) => {
        switch (key) {
          case 'componentName':
          case 'idComponent':
            return;
          case 'queryString':
            config['queryString'] = this.processFiltro(config['queryString'], this.dataRelated)
            break;

          case 'dataSourceKey':
            dataSend[config['dataSourceKey']] = this.dataRelated;
            return;
        }
        dataSend[key] = config[key];
      });
    }
    return dataSend;
  }

  processFiltro(query, data) {
    return query.replace(/\[([^\]]+)\]/g, (match, variable) => {
      return data.hasOwnProperty(variable) ? data[variable] : match;
    });
  }
}


